const $resortSelect = $('#js-resort-select');
const rooms = Array.from(document.querySelectorAll('.rooms'));
const triangle = document.getElementById('triangle');
let activeRoom = document.querySelector('.rooms.active');
const breakDown = document.getElementById('breakDown');
const lists = Array.from(document.querySelectorAll('.listOfBellsWhistles'));
const receive =  document.getElementById('youReceive');
const chartEl = document.getElementById('chart');

const removeAllClasses = () => {
    lists.forEach(list => {
        list.classList.remove('active');
    });
    rooms.forEach(room => {
        room.classList.remove('active');
    });
};

const resortSelectHandler = (event, data) => {
    if (data.item.value !== '') {
        removeAllClasses();
        document.querySelector(`.listOfBellsWhistles[data-rooms='${data.item.value}']`).classList.add('active');
        document.getElementById(`${data.item.value}`).classList.add('active');
    }
};

$resortSelect.selectmenu({
    appendTo: $resortSelect.parent(),
    change: resortSelectHandler
});

triangle.style.left = `${activeRoom.offsetLeft + (triangle.offsetWidth / 2)}px`;
receive.style.left = `${activeRoom.offsetLeft}px`;

const chart = _.debounce(() => {
    if (window.innerWidth > 768) {
        activeRoom = document.querySelector('.rooms.active');
        breakDown.style.marginTop = '';
        triangle.style.left = `${activeRoom.offsetLeft + (triangle.offsetWidth / 2)}px`;
        receive.style.left = `${activeRoom.offsetLeft}px`;
    } else if (window.innerWidth < 768) {
        breakDown.style.marginTop = '12rem';
    }
}, 300);

window.addEventListener('resize', chart);

document.onclick = (event) => {

    const ep = event.target;

    if (!Element.prototype.matches) {
        if (ep.webkitMatchesSelector) {
            ep.matches = ep.webkitMatchesSelector;
        }

        if (ep.msMatchesSelector) {
            ep.matches = ep.msMatchesSelector;
        }

        if (ep.mozMatchesSelector) {
            ep.matches = ep.mozMatchesSelector;
        }
    }

    if (ep.matches('.rooms, .rooms *')) {
        let clickTarget;

        if (!ep.matches('.rooms')) {
            clickTarget = event.target.parentElement;
        } else {
            clickTarget = event.target;
        }

        if (!clickTarget.classList.contains('.active')) {
            const roomNumbers = clickTarget.getAttribute('id');

            removeAllClasses();
            document.querySelector(`.listOfBellsWhistles[data-rooms='${roomNumbers}']`).classList.add('active');
            clickTarget.classList.add('active');
            triangle.style.left = `${clickTarget.offsetLeft + (triangle.offsetWidth / 2)}px`;
            receive.style.left = `${clickTarget.offsetLeft}px`;
        }
    }
};
